module.exports = __webpack_public_path__ + "img/30.3d963112.jpg";